import { render, staticRenderFns } from "./recipientIndex.vue?vue&type=template&id=0b61b7fd&scoped=true"
import script from "./recipientIndex.vue?vue&type=script&lang=js"
export * from "./recipientIndex.vue?vue&type=script&lang=js"
import style0 from "./recipientIndex.vue?vue&type=style&index=0&id=0b61b7fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b61b7fd",
  null
  
)

export default component.exports